import { z } from 'zod';

export const zodDeleteContractAttachmentEndpointSchema = z.tuple([
  z.literal('contracts'),
  z.uuid(),
  z.literal('attachments'),
  z.uuid(),
]);
